import '@babel/polyfill'
import Vue from 'vue'
import vuetify from './plugins/vuetify'
import dataLayer from './protos/dataLayer'
import VueResource from 'vue-resource'
import VueClipboard from 'vue-clipboard2'
import Digits from '@/App.vue'
import router from '@/router'
import store from '@/store'

Vue.config.productionTip = false

Vue.use(VueResource)
Vue.use(VueClipboard)

Vue.prototype.$dataLayer = new Vue(dataLayer)
//Vue.use(dataLayer)

new Vue({
  el: '#myui',
  store,
  router,
  vuetify,
  components: { Digits },
  template: '<Digits/>',
  created: function() {
    if (this.$store.state.isLoggedIn) {
      this.$store.dispatch('authorizeUser', {flow: 'resume', user: {persistance: true}})
    }
  }
})
